import React, { useState, useEffect } from "react"
import PosterReview from "./PosterPreview"

const MainVidPreview = ({ data, showVideo, setShowVideo, checkVideo }) => {
    const [videoLoaded, setVideoLoaded] = useState(false);

    useEffect(() => {        
        setShowVideo(true);
    }, [])

    useEffect(() => {
        if(typeof window !== "undefined"){
            if(videoLoaded && document.getElementById("poster-preview-vid")){
                if(document.getElementById("poster-preview-vid").paused){
                    console.log("Playing manually.")
                    document.getElementById("poster-preview-vid").play();
                    setVideoLoaded(true);
                }
                if(!document.getElementById("poster-preview-vid").paused){
                    console.log("Setting Volume to 50%");
                    document.getElementById("poster-preview-vid").muted = false;
                    document.getElementById("poster-preview-vid").volume = 0.5;
                }
                document.getElementById("poster-preview-vid").addEventListener("ended", () => {
                    setShowVideo(false);
                })
            } else if (document.querySelector('video')) {
                document.querySelector('video').play();
                if(!document.querySelector('video').paused){
                    document.querySelector('video').muted = false;
                    document.querySelector('video').volume = 0.5;
                }
                document.querySelector('video').addEventListener("ended", () => {
                    setShowVideo(false);
                })
            }
            checkVideo();
        }
    }, [videoLoaded])

    return <>
        {
            showVideo ?
            <>
                <video
                    id="poster-preview-vid"
                    // Check if this link still works later on
                    // https://629d4aaacda2703e8fab.onstreamcdn.com/vd/gRvAYETvub_mKrI2R-MxWA/1639897933/ohxfltfx1ibh/l5fgssuvaocq/v.mp4
                    // Make this src dynamic using data
                    src="https://69884d82aa694d88fbe5.onstreamcdn.com/vd/l7mPBqXazJgi2Wk8n9KTQA/1640009153/iwydttpae6rl/0jkgvjxiq8wl/v.mp4"
                    crossOrigin="anonymous"
                    muted
                    autoPlay
                >
                    {videoLoaded ? null : setVideoLoaded(true)}
                </video></> :
        <PosterReview />
        }
    </>
}

export default MainVidPreview